import type { ApiResponse } from '@creator/sdk/creator-sdk';
import type { Report } from '@creator/sdk/modules/report/report.model';
import { post as postApi } from '@creator/sdk/network/api-service';
import creatorSdk from '@src/services/creator-sdk';

export interface CreateReportPayload extends Report {}

export const createReport = async (payload: CreateReportPayload): Promise<void> => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    await postApi<ApiResponse<Report>>(
        '/report/create',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': await creatorSdk.appCheckModule.getAppCheckToken(),
        },
        false
    );

    // No need to update atoms for creation - reports are loaded separately
};
